import ChatWidget from './components/ChatWidget.vue'
import ChatAPI from './services/api'
import SocketService from './services/socket'
import chatStoreModule from './store'

export default {
  install: function (Vue, options) {
    options = options || {}

    var store = options.store
    var socketUrl = options.socketUrl || process.env.VUE_APP_CHAT_SOCKET_URL || 'https://api.consorciorioparkingcarioca.com:3002'
    var apiBaseUrl = options.apiBaseUrl || process.env.VUE_APP_API_BASE_URL || 'https://api.consorciorioparkingcarioca.com'
    var socketSecret = options.socketSecret || process.env.VUE_APP_CHAT_SOCKET_SECRET || ''
    var debug = options.debug || false

    // Validações
    if (!store) {
      throw new Error('[Chat Plugin] Vuex store é obrigatório. Use: Vue.use(ChatPlugin, { store })')
    }

    if (debug) {
      // console.log('[Chat Plugin] Configuração:', {
      //   socketUrl: socketUrl,
      //   apiBaseUrl: apiBaseUrl,
      //   hasStore: !!store
      // })
    }

    // Registra módulo Vuex (namespace do plugin)
    if (!store._modulesNamespaceMap['chatPlugin/']) {
      store.registerModule('chatPlugin', chatStoreModule)
      // console.log('[Chat Plugin] Módulo Vuex "chatPlugin" registrado.', {
      //   hasNamespace: !!store._modulesNamespaceMap['chatPlugin/'],
      //   keys: Object.keys(store._modulesNamespaceMap).filter(k => k.includes('chat'))
      // })
    } else {
      console.warn('[Chat Plugin] Módulo Vuex "chatPlugin" já está registrado.')
    }

    // Cria instâncias dos serviços
    var api = new ChatAPI(apiBaseUrl)
    var socket = new SocketService(socketUrl, socketSecret)

    // Expõe serviços no prototype do Vue
    Vue.prototype.$chat = {
      api: api,
      socket: socket,
      config: {
        socketUrl: socketUrl,
        apiBaseUrl: apiBaseUrl,
        debug: debug
      }
    }

    store.$chat = { api, socket }

    // Registra componente global
    Vue.component('chat-widget', ChatWidget)

    // Configura listeners do Socket.io após Vue estar pronto
    Vue.mixin({
      beforeCreate: function () {
        // var self = this

        // Só configura uma vez na instância raiz
        if (this === this.$root && socket && store) {
          // Listener para novas mensagens
          socket.on('chat:new-message', function (message) {
            store.dispatch('chatPlugin/handleNewMessage', message)
          })

          // Listener para usuário digitando
          socket.on('chat:user-typing', function (data) {
            // if (debug) console.log('[Chat Plugin] Usuário digitando:', data)
            store.commit('chatPlugin/SET_USER_TYPING', {
              roomId: data.roomId,
              userId: data.userId,
              typing: data.typing
            })
          })

          // Listener para mensagem lida
          socket.on('chat:message-read', function (data) {
            // if (debug) console.log('[Chat Plugin] Mensagem lida:', data)
            // Atualizar status das mensagens
          })

          // Listener para usuário online
          socket.on('chat:user-online', function (data) {
            // if (debug) console.log('[Chat Plugin] Usuário online:', data)
            store.commit('chatPlugin/ADD_ONLINE_USER', data.userId)
          })

          // Listener para usuário offline
          socket.on('chat:user-offline', function (data) {
            // if (debug) console.log('[Chat Plugin] Usuário offline:', data)
            store.commit('chatPlugin/REMOVE_ONLINE_USER', data.userId)
          })

          // Listener para status de conexão
          socket.on('connect', function () {
            store.commit('chatPlugin/SET_CONNECTED', true)
            // if (debug) console.log('[Chat Plugin] Socket conectado')
          })

          socket.on('disconnect', function () {
            store.commit('chatPlugin/SET_CONNECTED', false)
            // if (debug) console.log('[Chat Plugin] Socket desconectado')
          })
        }
      }
    })

    // if (debug) {
    //   console.log('[Chat Plugin] Instalado com sucesso!')
    // }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/chat-plugin/index.js